<!-- src/components/Applications/UtgreidslaSereign/Steps/Step7.vue -->
<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useVuelidate } from '@vuelidate/core'
import { sameAs } from '@vuelidate/validators'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'

// Use YOUR step/component names
import Umsaekjandi from '../../Shared/Umsaekjandi.vue'
import Tegund from './Step3.vue'
import Bankareikningur from './Step4.vue'
import Greidslutilhogun from './Step5.vue'
import UpplysingarUmLatna from './Step3_2.vue'
import StadgreidslaSkatta from './Step6.vue'
import StadfestingOrorku from './Step3_1.vue'
import PEP from '../../Shared/PEP.vue'

const { t } = useI18n()
const { umsokn } = useUmsokn()

const props = defineProps<{
  disable?: boolean
  onnurRettindi?: unknown
}>()

// Expand first panel by default
const expanded = ref<number[]>([0])

// helpers
const isAny = (val: number | undefined, list: number[]) => list.includes(Number(val))
</script>

<template>
  <div v-if="umsokn" class="col-sm-12">
    <v-col>
      <!-- Header -->
      <v-row>
        <v-col>
          <h2 class="forms__header">
            {{ t('umsokn_samantekt_header') }}
          </h2>
        </v-col>
      </v-row>

      <!-- Intro -->
      <v-row>
        <v-col>
          <p>{{ t('lifeyri_umsokn_step6_header2') }}</p>
        </v-col>
      </v-row>

      <!-- Summary expansion -->
      <v-row>
        <v-col class="application__summary">
          <v-expansion-panels v-model="expanded" multiple>
            <v-expansion-panel>
              <v-expansion-panel-title>
                {{ t('umsokn_samantekt_header') }}
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <div><Umsaekjandi :disable="true" /></div>
                <div class="m-t-100"><Tegund :disable="true" /></div>

                <!-- Bankareikningur: 0,1,2,3,4 -->
                <div class="m-t-100" v-if="isAny(umsokn?.tegund, [0,1,2,3,4])">
                  <Bankareikningur :disable="true" :hideHeader="true" />
                </div>

                <!-- Greiðslutilhögun (regular): 0,1,2,4 -->
                <div class="m-t-100" v-if="isAny(umsokn?.tegund, [0,1,2,4])">
                  <Greidslutilhogun :disable="true" :onnurRettindi="props.onnurRettindi" />
                </div>

                <!-- Upplysingar um látna: 2 -->
                <div class="m-t-100" v-if="umsokn?.tegund === 2">
                  <UpplysingarUmLatna :disable="true" />
                </div>

                <!-- Skattar: 0,1,2,3,4 -->
                <div class="m-t-100" v-if="isAny(umsokn?.tegund, [0,1,2,3,4])">
                  <StadgreidslaSkatta :disable="true" />
                </div>

                <!-- Örorku staðfesting: 1 -->
                <div class="m-t-100" v-if="umsokn?.tegund === 1">
                  <StadfestingOrorku :disable="true" />
                </div>

                <!-- PEP (summary, no disclaimer) -->
                <div class="m-t-100" v-if="isAny(umsokn?.tegund, [0,1,2,3,4])">
                  <PEP :disable="true" :showDisclamer="false" />
                </div>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<style scoped lang="scss">
.m-t-100 { margin-top: 100px; }
.forms__header {
  color: #194458;
  font-weight: 900;
  font-size: 28px;
  line-height: 1.25;
  margin: 0 0 12px;
}
</style>
